import React from "react";
import RiskManagementDashboard from "../DepartmentScreen/RiskManagementDashboard";
import OriginationMember from "../DepartmentScreen/OriginationMember";
import CommonInternalDashboard from "../DepartmentScreen/CommonInternalDashboard";
import InsurerStatsDashboard from "../DepartmentScreen/InsurerStatsDashboard";

function DashboardAll() {
  return (
    <div>
      <OriginationMember />
      <RiskManagementDashboard />
      <InsurerStatsDashboard />
      <CommonInternalDashboard />
    </div>
  );
}

export default DashboardAll;
